/* Nuava — tiroir panier.
   <nv-date-livraison> : remplace « 7 à 12 jours ouvrés » par les vraies dates (samedis, dimanches et jours fériés fixes sautés).
   <nv-pack-plus> : ajoute une couette identique en cliquant sur le « + » de sa ligne, pour que le panier d'Horizon
   fasse la mise à jour habituelle (puis nuvea-taies.js ajoute les taies).
   Éléments personnalisés : ils s'activent à chaque fois que le tiroir est redessiné. */

const FERIES = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'];

function ajouterJoursOuvres(depart, n) {
  const d = new Date(depart);
  let reste = n;
  while (reste > 0) {
    d.setDate(d.getDate() + 1);
    const jour = d.getDay();
    const mmjj = String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    if (jour !== 0 && jour !== 6 && !FERIES.includes(mmjj)) reste -= 1;
  }
  return d;
}

class NvDateLivraison extends HTMLElement {
  connectedCallback() {
    const min = Number(this.dataset.min) || 7;
    const max = Number(this.dataset.max) || 12;
    const now = new Date();
    const d1 = ajouterJoursOuvres(now, min);
    const d2 = ajouterJoursOuvres(now, max);
    const jour = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric' });
    const mois = (d) => d.toLocaleDateString('fr-FR', { month: 'long' });
    const debut = d1.getMonth() === d2.getMonth() ? jour(d1) : jour(d1) + ' ' + mois(d1);
    this.textContent = "Commandez aujourd'hui : livraison estimée entre le " + debut + ' et le ' + jour(d2) + ' ' + mois(d2);
  }
}

class NvPackPlus extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const bouton = event.target.closest('button');
      if (!bouton || bouton.disabled) return;
      const zone = this.closest('cart-items-component') || document;
      const ligne = zone.querySelector('#CartItem-' + CSS.escape(this.dataset.key));
      const plus = ligne && ligne.querySelector('button[name="plus"]');
      if (!plus || plus.disabled) return;
      bouton.disabled = true;
      plus.click();
    });
  }
}

if (!customElements.get('nv-date-livraison')) customElements.define('nv-date-livraison', NvDateLivraison);
if (!customElements.get('nv-pack-plus')) customElements.define('nv-pack-plus', NvPackPlus);
